// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { yellowMain, black500 } from '../../../constants/color';
import { useState, useRef } from 'react';
import { DownloadAction } from './DownloadAction';
import { uploadContainer } from './style';
import { useDropzone } from 'react-dropzone';
export const UploadAction = ({ text, disabled = false, selectedFile, h = 173, px = 10, py = 0, onFileUpload, direction = 'col', borderRadius = '25px', variant = 'contained', showMessage = 'no', errorBottom = -10, titleFont = 'default', subtitleFont = 'default', errormsg, singleFile = false, actionHeight = h - 20, neutral = false }) => {
    const [internalFile, setFile] = useState(null);
    const file = selectedFile === undefined ? internalFile : selectedFile;
    const fileInputRef = useRef(null);
    const onDrop = (acceptedFiles) => {
        if (!disabled && acceptedFiles.length > 0) {
            const droppedFile = acceptedFiles[0];
            setFile(droppedFile);
            onFileUpload(droppedFile);
        }
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        disabled,
        noClick: true,
        noKeyboard: true
    });
    const handleBrowseClick = () => {
        if (!disabled && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const clearFile = () => {
        if (disabled)
            return;
        setFile(null);
        onFileUpload(null);
        if (!disabled && fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    return (_jsxs(Box, { position: 'relative', height: 'auto', children: [_jsxs(Box, { ...getRootProps(), onClick: handleBrowseClick, role: file ? undefined : 'button', tabIndex: !file && !disabled ? 0 : -1, "aria-label": text, "aria-disabled": disabled, onKeyDown: (event) => {
                    if (event.target === event.currentTarget && !file && (event.key === 'Enter' || event.key === ' ')) {
                        event.preventDefault();
                        handleBrowseClick();
                    }
                }, sx: {
                    height: `${h}px`,
                    px: `${px}px`,
                    py: `${py}px`,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    '&:focus-visible': { outline: `3px solid ${yellowMain}`, outlineOffset: 2 },
                    borderRadius: borderRadius,
                    // `neutral` keeps the same layout but uses a white dropzone with a grey dashed border.
                    background: isDragActive ? (neutral ? '#F7F7F5' : '#FFE9B1') : variant === 'outLined' ? '' : neutral ? '#FFFFFF' : '#FFF7E0',
                    border: variant === 'outLined' ? '' : `1px dashed ${neutral ? '#A6ABB2' : yellowMain}`,
                    ...uploadContainer
                }, children: [_jsx("input", { ...getInputProps(), disabled: disabled, type: 'file', id: 'fileInput', ref: fileInputRef, style: { display: 'none' } }), file === null ? (_jsxs(Box, { sx: {
                            ...(direction === 'row'
                                ? {
                                    display: 'flex',
                                    gap: { xs: 2, md: 17 },
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }
                                : {})
                        }, children: [_jsx(Typography, { fontSize: titleFont === 'default' ? (direction === 'row' ? '14px' : '21px') : titleFont, fontWeight: 500, zIndex: 10, color: black500, children: text }), _jsxs(Typography, { zIndex: 10, fontSize: subtitleFont === 'default' ? '12px' : subtitleFont, fontWeight: 500, color: neutral ? '#5F6368' : yellowMain, children: ["Drag & drop file ", singleFile ? '' : '(s)', " to upload or browse"] })] })) : (_jsx(Box, { height: direction === 'row' ? h : `${actionHeight}px`, width: '100%', sx: {
                            display: 'flex',
                            alignItems: direction === 'row' ? 'center' : 'end'
                        }, onClick: (event) => {
                            event.stopPropagation();
                        }, children: _jsx(DownloadAction, { type: 'upload', fileName: file.name, clear: clearFile, width: '100%', fileSize: (file.size / 1024).toFixed(2) + ' KB' }) })), showMessage === 'yes' && file !== null && (_jsx(Box, { sx: {
                            position: 'absolute',
                            top: '50%',
                            left: '0%',
                            textAlign: 'center',
                            width: '100%'
                        }, children: _jsx(Typography, { fontSize: '21px', fontWeight: 500, children: "Complete!" }) }))] }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: file === null ? -19 : errorBottom, left: 5 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, color: '#FF0000', children: errormsg }) }))] }));
};
